import React from 'react';

const GoogleIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

const FEATURES = [
  {
    label: 'RECORD',
    title: '인용과 생각을 따로 남깁니다',
    description: '읽다 멈춘 문장은 인용으로, 스쳐간 생각은 생각으로. 페이지와 함께 쌓이면 한 권의 기록이 됩니다.'
  },
  {
    label: 'PACE',
    title: '완독까지의 페이스를 계산합니다',
    description: '목표 완독일을 정하면 오늘 읽어야 할 쪽수를 알려주고, 예정 진도와 실제 진도를 나란히 보여줍니다.'
  },
  {
    label: 'HABIT',
    title: '연속 독서일과 히트맵',
    description: '1년치 독서 활동을 한눈에. 매일 조금씩 읽는 습관이 눈에 보이는 형태로 남습니다.'
  },
  {
    label: 'MULTI',
    title: '여러 권을 동시에 읽어도 괜찮아요',
    description: '다섯 권, 열 권을 동시에 읽어도 각 책의 진행률과 남은 쪽수를 따로 추적합니다.'
  },
  {
    label: 'REVIEW',
    title: '기록에서 독후감으로',
    description: '쌓인 인용과 생각을 재료로 독후감 초안을 만듭니다. 백지에서 시작하지 않아도 됩니다.'
  },
  {
    label: 'RECALL',
    title: '필사로 되새기기',
    description: '저장해둔 문장을 다시 손으로 옮겨 적으며, 읽은 것을 읽은 채로 두지 않습니다.'
  }
];

export const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-white dark:bg-ink-950">
    <div className="text-center">
      <h1 className="font-display text-3xl text-ink-900 dark:text-ink-50">북러닝</h1>
      <p className="label mt-4">LOADING</p>
    </div>
  </div>
);

const Landing = ({ signInWithGoogle, authError }) => (
  <div className="min-h-screen bg-white dark:bg-ink-950 text-ink-900 dark:text-ink-100">
    <div className="mx-auto w-full max-w-5xl px-6 py-20">
      {/* Hero */}
      <section className="py-16 sm:py-24">
        <p className="label">BOOK RUNNING</p>
        <h1 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.05]">
          읽은 것을<br />읽은 채로 두지 않기
        </h1>
        <p className="mt-8 max-w-xl text-base sm:text-lg leading-relaxed text-ink-600 dark:text-ink-400 font-sans">
          문장을 남기고, 생각을 덧붙이고, 완독까지의 페이스를 확인합니다.
          여러 권을 동시에 읽는 사람을 위한 독서 기록장.
        </p>

        {authError && (
          <div className="mt-8 max-w-md surface p-4">
            <p className="text-sm text-ink-900 dark:text-ink-100 font-sans">{authError.message}</p>
            {authError.code && (
              <p className="mt-1 text-xs text-ink-500 font-sans">{authError.code}</p>
            )}
          </div>
        )}

        <button onClick={signInWithGoogle} className="btn-primary mt-10">
          <GoogleIcon />
          Google로 시작하기
        </button>
      </section>

      {/* Features */}
      <section className="mt-16 border-t border-ink-200 dark:border-ink-800 pt-16">
        <p className="label">WHAT IT DOES</p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {FEATURES.map(feature => (
            <div key={feature.label}>
              <p className="label">{feature.label}</p>
              <h3 className="mt-3 font-display text-xl leading-snug text-ink-900 dark:text-ink-50">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-600 dark:text-ink-400 font-sans">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      <footer className="mt-20 border-t border-ink-200 dark:border-ink-800 pt-8">
        <p className="text-xs text-ink-500 dark:text-ink-400 font-sans">북러닝 · Book Running</p>
      </footer>
    </div>
  </div>
);

export default Landing;
